import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 py-16 text-center">
      <h1 className="text-6xl font-bold text-primary mb-6">404</h1>
      <h2 className="text-2xl font-semibold mb-4">Seite nicht gefunden</h2>
      <p className="text-muted-foreground mb-8 max-w-md">
        Die von Ihnen gesuchte Seite existiert leider nicht oder wurde möglicherweise verschoben.
      </p>
      <Button asChild>
        <Link to="/" className="flex items-center gap-2">
          <Home size={18} />
          <span>Zurück zur Startseite</span>
        </Link>
      </Button>
    </div>
  );
};

export default NotFound; 